<template>
  <a :href="`https://wa.me/${phone}`" target="_blank" class="wht-icon">
  <FontAwesomeIcon :icon="faWhatsapp" />
  </a>

  <a :href="`tel:+${phone}`" target="_blank" class="call-icon">
  <FontAwesomeIcon :icon="faPhone" />
  </a>

</template>

<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { ref, onMounted } from "vue";

const phone = ref("");

onMounted(function () {
  fetch("/data.json")
    .then((res) => res.json())
    .then((data) => {
      phone.value = data.phone;
    })
    .catch((err) => console.error(err));
});
</script>

<style scoped>
.wht-icon {
  position: fixed;
  bottom: 20px;
  left: 20px;

  width: 55px;
  height: 55px;

  background-color: #80d0c7;
  color: white;

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 22px;
  cursor: pointer;
  z-index: 9999;
}
.call-icon {
  position: fixed;
  bottom: 20px;
  right: 20px;

  width: 55px;
  height: 55px;

  background-color: #80d0c7;
  color: white;

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 22px;
  cursor: pointer;
  z-index: 9999;
}
</style>
